import posthog from 'posthog-js';

let client: any = {};
let initialized = false;

if (typeof window !== 'undefined') {
  client = posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    capture_pageview: false, // false because we capture ourselves in PostHogPageView
    capture_pageleave: true,
    enable_heatmaps: true,
  });

  initialized = true;
}

export { client, posthog, initialized };
